/* eslint react/prop-types: 0 */
import React, { Component } from "react";
import axios from "axios";
import { TweenLite } from "gsap";

// Components
import Header from "../../components/Header/Header";
import DetailsCard from "../../components/DetailsCard/DetailsCard";
import PdfCard from "../../components/PdfCard/PdfCard";
import CatalogInputControl from "../../components/CatalogInputControl/CatalogInputControl";
import Footer from "../../components/Footer/Footer";

export default class Results extends Component {

  constructor(props) {
    super(props);
    this.state = {
      input: "",
      catalogFound: false,
      catalogReferenceNumber: "",
      download: "",
      preview: "",
      details: {},
      error: false
    };
    this.returnHome = this.returnHome.bind(this);
  }

  returnHome() {
    this.props.history.push("/");
  }

  async componentDidMount() {

    let catalogReferenceNumber = this.props.location.pathname.split("/").pop();
    const url = `https://api.foundersportgroup.com/api/catalogs/archived-playbooks/lookup/${catalogReferenceNumber}`;

    try {
      const response = await axios.get(url);
      // throw new Error("this is test")

      if (!response.data) { throw new Error("item not found"); }

      TweenLite.from(".results .contents", .15, {opacity:0, delay:.15});
      this.setState({
        catalogFound: true,
        catalogReferenceNumber: catalogReferenceNumber,
        download: response.data.downloadUrl,
        preview: response.data.previewUrl,
        details: response.data,
        error: false
      });
    } catch (err) {
      TweenLite.from(".results .contents", .15, {opacity:0, delay:.15});
      this.setState({
        catalogFound: false,
        catalogReferenceNumber: catalogReferenceNumber,
        download: "",
        preview: "",
        details: {},
        error: true
      });
    }

    if (this.state.error === true) {
      var inputBox = document.getElementById("catalog-input");
      inputBox.value = this.state.catalogReferenceNumber;
    }
  }

  render() {
    return (
      <div className="results">
        <Header />
        <div className="contents">
          {this.state.catalogFound ?
            <div>
              <div className="main-title wrapping-title">
                <span>{this.state.details.schoolName}</span>
                <span>Custom {this.state.details.playbookTemplateName}</span>
              </div>
              <div className="wrapper">
                <div className="container">
                  <PdfCard preview={this.state.preview} download={this.state.download} />
                  <DetailsCard details={this.state.details} />
                </div>
                <Footer isVisible={false}/>
              </div>
            </div>
            :
            null
          }
          {this.state.error ?
            <div className="wrapper">
              <div className="playbook-field-image" />
              <div className="playbook-page-container">
                <div className="landing-title-container">
                  <div className="landing-title">
                    <div>Custom Catalog Look Up</div>
                  </div>
                  <div className="landing-subtitle">
                    <div>Enter your catalog reference # to view your catalog</div>
                  </div>
                </div>
                <div className="error">
                  <div className="message">
                    <CatalogInputControl />
                    <h2 style={{ marginTop: "20px", fontSize: "20px" }}>Could not find Catalog Reference # {this.state.catalogReferenceNumber}</h2>
                  </div>
                  <Footer isVisible={true} />
                </div>
              </div>
            </div>
            :
            null
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Results/Results.js